import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChromecast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChromecast"><Path d="M2 3V7C9.73199 7 16 13.268 16 21H22V3H2Z" fill="currentColor"/><Path d="M2 15C5.31371 15 8 17.6863 8 21H10C10 16.5817 6.41828 13 2 13V15Z" fill="currentColor"/><Path d="M12 21C12 15.4772 7.52285 11 2 11V9C8.62742 9 14 14.3726 14 21H12Z" fill="currentColor"/><Path d="M2 19C3.10457 19 4 19.8954 4 21H6C6 18.7909 4.20914 17 2 17V19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChromecast;
